<template>
  <div :class="[ `trend--${width}` ]">
    <div class="trend-inner">
      <div :class="[ 'trend-front', color ]">
        {{name}}
        <img
          v-if="icon"
          class="figma"
          :src="getImgUrl()"
          alt=""
        >
      </div>
      <div :class="['trend-back', color, 'outline' ]">
        {{name}}
        <p class="trend-text" v-if="text">{{text}}</p>
        <a v-if="link" :src="link" class="trend-text trend-link">view now ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrendComponent',
  props: {
    width: Number,
    color: String,
    icon: String,
    name: String,
    text: String,
    link: String,
  },
  methods: {
    getImgUrl() {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      return require(`../assets/images/svgs/${this.icon}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/text";

.trend {
  @extend h4;
  border: 0;
  color: var(--background-color);
  background-color: transparent;
  display: flex;
  width: calc(100% - (2 * 0.5rem));
  height: calc(100% - (2 * 0.5rem));
  max-width: 100%;
  margin: 0.5rem;

  &--1 {
    @extend .trend;
    aspect-ratio: 1/1;
  }

  &--2 {
    @extend .trend;
    aspect-ratio: 2/1;
  }
}

.trend-inner {
  position: relative;
  background-color: transparent;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.trend:hover .trend-inner {
  transform: rotateY(180deg);
}

.trend-front, .trend-back {
  border-radius: var(--border-radius);
  padding: 0.875rem;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}
.trend-back {
  transform: rotateY(180deg);
  background-color: var(--background-color);
  color: var(--light-background-color);
}

.trend-text {
  font-family: Poppins-ExtraLight, Helvetica, Arial, sans-serif;
  font-size: 20px;
}

.trend-link {
  cursor: pointer;
  text-decoration: none;
}

.figma {
  object-fit: cover;
  height: auto;
  margin-top: 10%;
}

.premiere {
  object-fit: cover;
  height: 100%;
  margin-top: 10%;
}

.ui {
  width: 100%;
  align-self: center;
}

.github {
  width: 70%;
  align-self: center;
}

.white {
  background-color: var(--white);
  border: 2px solid var(--white);
}
.red {
  background-color: var(--red);
  border: 2px solid var(--red);
}
.purple {
  background-color: var(--purple);
  border: 2px solid var(--purple);
}
.green {
  background-color: var(--green);
  border: 2px solid var(--green);
}
.blue {
  background-color: var(--blue);
  border: 2px solid var(--blue);
}
.yellow {
  background-color: var(--yellow);
  border: 2px solid var(--yellow);
}

.outline {
  background-color: var(--background-color);
  color: var(--light-background-color);
}
</style>
